import { z } from 'zod'

export type LoginFormData = {
  email: string
  password: string
}

export const loginFormSchema = z.object({
  email: z.email('loginForm.fields.email.errors.invalid_string').max(256),
  password: z
    .string()
    .min(8, 'loginForm.fields.password.errors.too_small')
    .max(70, 'loginForm.fields.password.errors.too_big')
})
